import React from 'react';

const features = [
  { icon: '⚡', title: 'Fast Search', description: 'Quickly discover products using intelligent matching.' },
  { icon: '📂', title: 'Category Intelligence', description: 'Smart filtering and hierarchy for easy exploration.' },
  { icon: '💸', title: 'Local Currency Support', description: 'View prices in Nigerian Naira (₦) — no conversion stress.' },
];

const sponsored = [
  {
    abbr: 'KP',
    title: 'Kamsiparts',
    tag: 'Auto Parts',
    blurb: 'Powering mobility with genuine auto parts sourcing and distribution.',
    href: 'https://kamsiparts.com/',
    cta: 'Shop Auto Parts',
  },
  {
    abbr: 'KH',
    title: 'KambiHome',
    tag: 'Lifestyle',
    blurb: 'Simplifying lifestyle with trusted home and living solutions.',
    href: 'https://kambihome.com',
    cta: 'Explore Home',
  },
  {
    abbr: '3PL',
    title: 'Kambi3PL',
    tag: 'Logistics',
    blurb: 'Delivering efficiency with smart logistics and last-mile fulfillment.',
    href: 'https://kambi3pl.com',
    cta: 'Start Shipping',
  },
  {
    abbr: 'AI',
    title: 'MazesAI',
    tag: 'AI & Data',
    blurb: 'Driving intelligence with AI-powered data and automation.',
    href: 'https://mazesai.com',
    cta: 'Discover MazesAI',
  },
];

const FeatureHighlights = () => {
  return (
    <section className="bg-green-50 py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-10">
          Why Nigerians Love KambiHome
        </h2>

        {/* Features */}
        <div className="grid gap-6 md:grid-cols-3">
          {features.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="text-4xl mb-4 animate-bounce">{item.icon}</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Sponsored Ads */}
        <div className="mt-14 text-center">
          <span className="inline-block text-xs font-medium uppercase tracking-wide bg-green-100 text-green-800 px-3 py-1 rounded-full mb-2">
            Sponsored
          </span>
          <h3 className="text-xl sm:text-2xl font-semibold text-gray-900">TCHIKAMALOR Global Ecosystem Platforms</h3>
          <p className="text-gray-600 mt-1 mb-6">One Ecosystem. Multiple Solutions. Unified Purpose.</p>

          <div className="grid gap-6 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {sponsored.map((ad) => (
              <a
                key={ad.title}
                href={ad.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group cursor-pointer"
                aria-label={`${ad.title} - ${ad.tag}`}
              >
                <div className="relative rounded-2xl p-[1px] bg-gradient-to-br from-green-300/60 via-emerald-300/40 to-green-600/50">
                  <div className="rounded-2xl bg-white h-full flex flex-col shadow-sm transition-transform duration-200 group-hover:scale-105 group-hover:shadow-2xl">
                    <div className="relative rounded-t-2xl overflow-hidden">
                      <div className="aspect-[16/9] bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center border-b border-gray-100">
                        <span className="font-extrabold tracking-widest text-gray-700 text-lg">
                          {ad.abbr}
                        </span>
                      </div>
                      <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute -left-1/3 top-0 h-full w-1/2 rotate-[-20deg] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                      </div>
                    </div>

                    <div className="flex-1 flex flex-col p-4">
                      <div className="flex items-center justify-between mb-1">
                        <h4 className="font-semibold text-gray-900">{ad.title}</h4>
                        <span className="text-[11px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
                          {ad.tag}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 flex-1">{ad.blurb}</p>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex items-center justify-center rounded-lg bg-green-600 text-white text-sm font-medium py-2 transition-all hover:bg-green-700 active:scale-95"
                      >
                        {ad.cta}
                      </button>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureHighlights;
